module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message"
  }, [_c('div', {
    staticClass: "sc-message--content",
    class: {
      sent: _vm.message.author === 'me', received: _vm.message.author !== 'me'
    }
  }, [_c('div', {
    staticClass: "sc-message--avatar",
    style: ({
      backgroundImage: ("url(" + _vm.chatImageUrl + ")")
    })
  }), (_vm.message.type === 'text') ? _c('TextMessage', {
    attrs: {
      "data": _vm.message.data
    }
  }) : (_vm.message.type === 'emoji') ? _c('EmojiMessage', {
    attrs: {
      "data": _vm.message.data
    }
  }) : (_vm.message.type === 'file') ? _c('FileMessage', {
    attrs: {
      "data": _vm.message.data
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03081548"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/Message.vue
// module id = 1196
// module chunks = 1